import './game-action-button.scss';

import { memo } from 'react';

import { Button, type ButtonProps } from '@/shared/ui/Button';

export interface GameActionButtonProps {
  label: string;
  variant?: ButtonProps['variant'];
  outline?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

function GameActionButtonComponent({
  label,
  variant,
  outline,
  disabled = false,
  onClick,
  className,
}: GameActionButtonProps) {
  return (
    <Button
      type="button"
      className={`game-action-btn${className ? ` ${className}` : ''}`}
      size="lg"
      variant={variant}
      outline={outline}
      onClick={onClick}
      disabled={disabled || !onClick}>
      <span className="game-action-btn__text">{label}</span>
      {!variant && !disabled && <span className="game-action-btn__shine" />}
    </Button>
  );
}

export const GameActionButton = memo(GameActionButtonComponent);
